"use client";

import { renderSVG } from "uqr";

/** A QR code of an `otpauth://` URI for authenticator apps, generated in the browser from data the API returned. */
export function TotpQr({ uri }: { uri: string }) {
  return (
    <div
      className="mx-auto size-48 rounded-(--radius-control) border border-border bg-paper p-2"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG built by uqr from our own data.
      dangerouslySetInnerHTML={{ __html: renderSVG(uri) }}
    />
  );
}
